<div class="bg-m0 flex-grow select-none flex-col overflow-y-auto p-9">
  <div
    data-cy="addEnvironmentDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Add Environment</div
  >

  <form
    class="flex w-80 flex-col"
    [formGroup]="addEnvironmentForm"
    (ngSubmit)="add()"
  >
    <input
      autocomplete="off"
      #envId
      spellcheck="false"
      data-cy="addEnvironmentDialogEnvironmentIdInput"
      class="form-input border-s3 focus:border-m600 mt-9 rounded"
      [ngClass]="{
        'border-r600':
          addEnvironmentForm.controls['envId'].invalid &&
          addEnvironmentForm.controls['envId'].touched
      }"
      formControlName="envId"
      placeholder="Name"
    />
    <m-validation
      [control]="addEnvironmentForm.controls['envId']"
    ></m-validation>

    <div class="mt-6">
      <button
        data-cy="addEnvironmentDialogAddButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Add</button
      >

      <button
        data-cy="addEnvironmentDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
